import { inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { PATHS } from '../../../const/paths';

/**
 * Périmètre du patrimoine actuellement consulté : `null` = personnel, sinon
 * l'id de la société (patrimoine professionnel).
 *
 * Les données et documents diffèrent selon le périmètre : l'id de société est
 * transmis au backend (en-tête `X-Societe-Id`, cf. patrimoineScopeInterceptor)
 * pour les lectures ET les écritures, sans modifier chaque formulaire.
 *
 * Le périmètre n'est actif que dans la zone « Mon patrimoine » : il est remis à
 * `null` (personnel) dès que l'utilisateur quitte ce sous-arbre de routes, pour
 * ne pas contaminer les autres écrans (gestion courante, etc.).
 */
@Injectable({ providedIn: 'root' })
export class PatrimoineScopeService {
  private readonly _societeId = signal<number | null>(null);
  readonly societeId = this._societeId.asReadonly();

  constructor() {
    const router = inject(Router);
    router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        if (!e.urlAfterRedirects.startsWith('/' + PATHS.MY_HERITAGE)) {
          this._societeId.set(null);
        }
      });
  }

  /** Définit le périmètre : id de société (professionnel) ou null (personnel). */
  setSocieteId(societeId: number | null): void {
    this._societeId.set(societeId);
  }
}
